import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, initializeMsal } from "@services/auth";
import App from "./App";
import "./styles/index.css";

// Initialize MSAL (handles redirect callbacks + active account) before rendering
initializeMsal()
  .catch(err => {
    console.error("MSAL init failed; continuing without auth:", err);
  })
  .finally(() => {
    ReactDOM.createRoot(document.getElementById("root")!).render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  });
